// src/pages/ShippingPage.js
import React from 'react';

export default function ShippingPage() {
  return (
    <div className="container" style={{ maxWidth: '800px', margin: '40px auto', padding: '20px' }}>
      <h1 style={{ marginBottom: '30px', color: 'var(--primary)' }}>Dërgesa</h1>
      
      <div style={{ background: '#f8f9fa', padding: '30px', borderRadius: '8px' }}>
        <p style={{ fontSize: '16px', lineHeight: '1.6', marginBottom: '20px' }}>
          Në momentin e porosisë, do të merrni një konfirmim lidhur me shpejtësinë e dërgesës së porosisë.
        </p>
        
        <p style={{ fontSize: '16px', lineHeight: '1.6' }}>
          Zakonisht për porositë të cilat janë në stok, dërgesa bëhet brenda <strong>2 ditëve të punës</strong>.
        </p>
      </div>
    </div>
  );
}